export default "__VITE_ASSET__YDLWN$Xq__"